import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 448"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "User Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M224 224c84.493 0 137.302-91.467 95.055-164.64A109.76 109.76 0 0 0 224 4.48c-84.493 0-137.302 91.467-95.055 164.64A109.76 109.76 0 0 0 224 224m-39.188 41.16c-84.464 0-152.892 68.428-152.892 152.892 0 14.063 11.405 25.468 25.468 25.468h333.224c14.063 0 25.468-11.405 25.468-25.468 0-84.464-68.428-152.892-152.892-152.892z"
    }, null, -1)
  ])))
}
export default { render: render }